import { Warn, watchAddedNodes } from './utils';

import initLazyload from './_components/03-organisms/addons/lazyload';

export class D3Core {
  constructor() {
    this.init();
  }

  async init() {
    document.addEventListener('DOMContentLoaded', () => {
      initLazyload();
      watchAddedNodes((elements) => {
        elements.map((el) => {
          this.launchPlugin(el);
        });
      }, '[data-plugin]');
    });
  }

  launchPlugin(el) {
    // plugin already set
    if (!el || el.plugin) return;

    const names = el.dataset?.plugin?.split('|');

    //check if exist
    if (!names) {
      Warn('can not find data-plugin for element', el);
      return;
    }

    let o;
    try {
      o = JSON.parse(el.dataset.options ?? '{}');
    } catch (e) {
      Warn('Options parsing error for element', el, e, el.dataset.options);
      o = {};
    }

    names.map(async (pluginName) => {
      const PluginClass = await this.getPlugin(pluginName);

      if (!PluginClass) {
        Warn(`Plugin ${pluginName} does not exist`);
        return;
      }

      try {
        const pluginInstance = new PluginClass(el, o);
        el.plugin = pluginInstance;
        await pluginInstance.init();
      } catch (er) {
        Warn('plugin function error', er, el, o, pluginName);
      }
    });
  }

  async getPlugin(pluginName) {
    try {
      return (await import(/* webpackChunkName: "plugins/[request]" */ `./_modules/${pluginName}`))
        .default;
    } catch (e) {
      Warn(`Plugin ${pluginName} not found`, e);
      return null;
    }
  }

  static getInstance(win = window) {
    win.D3 = win.D3 || {};
    win.D3.core = win.D3.core || new D3Core();

    return win.D3.core;
  }
}

const d3CoreInstance = D3Core.getInstance(window);
export default d3CoreInstance;
